import { useTranslation } from "@opendash/i18n";
import { Form, FormItemProps } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { SaveTicketValues } from "../..";
import { SourceSelect } from "../../../../../_shared";
import { useFieldConfig } from "../../hooks/useFieldConfig";

type Props = {
  type: "dropdown";
} & FormItemProps<SaveTicketValues>;

export const SourceInput = observer((props: Props) => {
  const t = useTranslation();
  const config = useFieldConfig("source");

  if (config && config.hidden) return <></>;

  const label =
    config?.label === "-"
      ? ""
      : config?.label || t("maintenance:ticket.create.source.label");

  return (
    <Form.Item<SaveTicketValues>
      name="source"
      label={label}
      help={config?.help}
      rules={[
        {
          required: config?.required,
          message: t("maintenance:ticket.create.source.error.empty"),
        },
      ]}
      {...props}
    >
      {props.type === "dropdown" && (
        <SourceSelect
          size="small"
          style={{ minWidth: 200 }}
          maxTagCount="responsive"
          placeholder={t("maintenance:ticket.create.source.placeholder")}
        />
      )}
    </Form.Item>
  );
});
